import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import FormInput from '@shared/atoms/FormFields/FormInput';
import Drawer from '@shared/atoms/Drawer';
import theme from '@shared/themes/default';

import { useForm } from '@shared/utils';

const DrawerContent = styled.div`
  background: ${theme.palette.darkDistinct};
  margin: 0 ${theme.spacing.s};
  padding: ${theme.spacing.s} ${theme.spacing.s} ${theme.spacing['2xl']};
  width: 496px;
`;

const LearningPointDrawer = ({ learningPoint, onClose, onSave, open }) => {
  const { t } = useTranslation();

  const {
    disableSubmit,
    edited,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    properties,
    setDefaults,
    values,
  } = useForm({
    fields: {
      label: {
        required: true,
        maxLength: 150,
      },
    },
    onSubmit: ({ label }) => onSave({ id: learningPoint.id, label }),
  });

  useEffect(() => {
    setDefaults({
      label: learningPoint?.label || '',
    });
  }, [learningPoint]);

  return (
    <Drawer
      anchor="right"
      edited={edited}
      onClose={onClose}
      onSave={handleSubmit}
      open={open}
      saveDisabled={disableSubmit}
      title={t('backoffice.courses.descriptionTab.learningPointEdit')}
    >
      <DrawerContent>
        <FormInput
          autoFocus
          id="label"
          key="label"
          name="label"
          label={t('backoffice.courses.descriptionTab.learningPoint')}
          maxRows={0}
          multiline
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          placeholder={t(
            'backoffice.courses.descriptionTab.learningPointPlaceholder'
          )}
          properties={properties}
          theme="dark"
          values={values}
          showMaxLength
        />
      </DrawerContent>
    </Drawer>
  );
};

LearningPointDrawer.propTypes = {
  learningPoint: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default LearningPointDrawer;
